import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularComboComponent } from './angular-combo.component';
import { FormsModule } from "@angular/forms";
@NgModule({
    imports: [CommonModule,
        FormsModule
],
    declarations: [AngularComboComponent],
    exports: [AngularComboComponent],
    providers: []
})
export class AngularComboModule { }


// WEBPACK FOOTER //
// ./src/angular_library/components/combo/angular-combo.module.ts